import React from "react";
import { Card, ListGroup, Button, Spinner } from "react-bootstrap";
import {
  FaFilePdf,
  FaFileImage,
  FaFileAlt,
  FaFileWord,
  FaClipboard,
  FaDownload,
} from "react-icons/fa";

const getFileIcon = (fileName) => {
  const ext = fileName?.split(".").pop()?.toLowerCase();
  if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext))
    return <FaFileImage color="#4dabf7" size={20} />;
  if (["pdf"].includes(ext)) return <FaFilePdf color="#f03e3e" size={20} />;
  if (["doc", "docx"].includes(ext)) return <FaFileWord color="#228be6" size={20} />;
  return <FaFileAlt color="#868e96" size={20} />;
};

const formatDate = (isoString) => {
  if (!isoString) return "N/A";
  return new Date(isoString).toLocaleDateString();
};

const buttonStyle = {
  borderRadius: "8px",
  minWidth: "40px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const SavedFilesList = ({
  files,
  isDark,
  loading,
  handleDownloadAndShare,
  activeActionId,
  isProcessing,
}) => {
  return (
    <Card
      className="shadow-lg border-0"
      style={{
        height: "100%",
        backgroundColor: isDark ? "#1e1e1e" : "#ffffff",
        color: isDark ? "#f8f9fa" : "#212529",
        transition: "all 0.3s ease",
        maxHeight: "75vh",
        overflowY: "auto",
      }}
    >
      <Card.Header
        className="fw-bold text-center"
        style={{
          backgroundColor: isDark ? "#2a2a2a" : "#f8f9fa",
          color: isDark ? "#f1f1f1" : "#212529",
          borderBottom: isDark ? "1px solid #333" : "1px solid #ddd",
        }}
      >
        Saved Files
      </Card.Header>

      {loading ? (
        <div className="text-center py-5">
          <Spinner animation="border" variant={isDark ? "light" : "dark"} />
          <div className="mt-3">Loading files...</div>
        </div>
      ) : files.length === 0 ? (
        <div
          className="text-center py-4"
          style={{ color: isDark ? "#bbb" : "#666" }}
        >
          No saved files yet.
        </div>
      ) : (
        <ListGroup variant="flush">
          {files.map((file, index) => {
            const { fileName, uploadedAt, shareId } = file;

            return (
              <ListGroup.Item
                key={shareId || index}
                className="d-flex justify-content-between align-items-center px-3"
                style={{
                  backgroundColor: isDark ? "#1e1e1e" : "#ffffff",
                  color: isDark ? "#f8f9fa" : "#212529",
                  borderBottom: isDark ? "1px solid #333" : "1px solid #eee",
                }}
              >
                <div className="d-flex align-items-center gap-3">
                  {getFileIcon(fileName)}
                  <div>
                    <div className="fw-semibold">
                      {fileName.length > 25
                        ? fileName.substring(0, 25) + "..."
                        : fileName}
                    </div>
                    <div
                      style={{
                        fontSize: "0.85rem",
                        color: isDark ? "#adb5bd" : "#6c757d",
                      }}
                    >
                      Uploaded: {formatDate(uploadedAt)}
                    </div>
                  </div>
                </div>

                <div className="d-flex gap-2">

                  {/* Copy link */}
                  <Button
                    variant={isDark ? "light" : "dark"}
                    size="sm"
                    title="Copy share link"
                    disabled={isProcessing}
                    onClick={() => handleDownloadAndShare(shareId, false)}
                    style={buttonStyle}
                  >
                    {activeActionId === shareId ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      <FaClipboard />
                    )}
                  </Button>

                  {/* Download Button */}
                  <Button
                    variant={isDark ? "light" : "dark"}
                    size="sm"
                    title="Download file"
                    disabled={isProcessing}
                    onClick={() => handleDownloadAndShare(shareId, true)}
                    style={buttonStyle}
                  >
                    {activeActionId === shareId ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      <FaDownload />
                    )}
                  </Button>
                </div>
              </ListGroup.Item>
            );
          })}
        </ListGroup>
      )}
    </Card>
  );
};

export default SavedFilesList;
